import { render, staticRenderFns } from "./OrderFast.vue?vue&type=template&id=6af61ed5&scoped=true"
import script from "./OrderFast.vue?vue&type=script&lang=ts"
export * from "./OrderFast.vue?vue&type=script&lang=ts"
import style0 from "./OrderFast.vue?vue&type=style&index=0&id=6af61ed5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af61ed5",
  null
  
)

export default component.exports